module.exports = __webpack_public_path__ + "static/media/team-bob.816bc5e7.jpg";